import { type StateCode } from "./states";

/**
 * The two letter code of each Brazilian state published by the IBGE, in the order of `DATA` in
 * `./states` (sorted by state name in the "pt-BR" locale), on its own so that a util which only
 * needs the codes does not carry the whole states table into a consumer's bundle.
 *
 * Generated by `node ./scripts/states.ts`. Do not edit by hand.
 *
 * @see Official: https://servicodados.ibge.gov.br/api/docs/localidades
 */
export const STATE_CODES: readonly StateCode[] = [
	"AC",
	"AL",
	"AP",
	"AM",
	"BA",
	"CE",
	"DF",
	"ES",
	"GO",
	"MA",
	"MT",
	"MS",
	"MG",
	"PA",
	"PB",
	"PR",
	"PE",
	"PI",
	"RJ",
	"RN",
	"RS",
	"RO",
	"RR",
	"SC",
	"SP",
	"SE",
	"TO",
];
